module.exports = __webpack_public_path__ + "media/customizations/regencyatoldetowne/back-8abb148b8162400ddd8ce1793af494b2.jpg";